import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {Translation} from "./translation";


const routes: Routes = [
  {
    path: 'translations',
    component: Translation,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TranslationRoutingModule {}
